<template>
  <v-dialog v-model="isPromptVisible" persistent max-width="1200px">
    <v-card v-if="displayMode === 'loader'">
      <div class="progressWrapper">
        <v-progress-circular :size="70"
                             :width="7"
                             color="green"
                             indeterminate
                             class="spinner" />
      </div>
    </v-card>
    <v-card v-if="displayMode === 'noData'">
      <div class="progressWrapper">
        <button class="dismissButton" @click="dismiss">Dismiss</button>
        <div class="noData">No Data</div>
      </div>
    </v-card>
    <v-card v-if="displayMode === 'patientView'">
      <div class="patientViewerOuterWrapper">
        <div class="patientViewWrapper">

          <div class="patientActions">
            <div class="actionLabel">Initiate</div>
            <div class="actionWrapper">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="actionBtn"
                       v-bind="attrs"
                       v-on="on"
                       @click="_showIvrInitiator">
                    <v-icon>mdi-phone</v-icon>
                  </div>
                </template>
                <span>Initiate IVR</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="actionBtn"
                       v-bind="attrs"
                       v-on="on"
                       @click="_showEmailComposer">
                    <v-icon>mdi-email-edit</v-icon>
                  </div>
                </template>
                <span>Compose Email</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="actionBtn"
                       v-bind="attrs"
                       v-on="on"
                       @click="_showMessageComposer">
                    <v-icon>mdi-message-draw</v-icon>
                  </div>
                </template>
                <span>Compose SMS</span>
              </v-tooltip>
            </div>
          </div>

          <!--<div class="patientAccountSync">
            <div class="actionLabel">Sync Account</div>
            <div class="actionWrapper">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="actionBtn"
                       v-bind="attrs"
                       v-on="on"
                       @click="_showAccountSync">
                    <v-icon>mdi-sync</v-icon>
                  </div>
                </template>
                <span>Sync Account</span>
              </v-tooltip>
            </div>
          </div>-->

          <button class="dismissButton" @click="dismiss">Dismiss</button>
          <div class="sectionWrapper">
            <div class="sectionHeader">Demographic Info</div>
            <div class="row demographicSection">
              <div class="col-md-12 rightPart">
                <div class="row" v-if="demoGrahpicInfo">
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">First Name</p>
                      <p class="value">
                        {{ demoGrahpicInfo.FirstName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Last Name</p>
                      <p class="value">
                        {{ demoGrahpicInfo.LastName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Email</p>
                      <p class="value">
                        {{ demoGrahpicInfo.Email }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Phone Number</p>
                      <p class="value">
                        {{ demoGrahpicInfo.MobileNumber || "--" }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper noBorder">
                      <p class="label">Date of birth</p>
                      <p class="value">
                        {{ demoGrahpicInfo.DOB? _getFormatted(demoGrahpicInfo.DOB, "MM/DD/YYYY") : "--" }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper noBorder">
                      <p class="label">Patient ID</p>
                      <p class="value demoGrahpicInfoID">
                        {{ demoGrahpicInfo.PatientID }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Guarantor Info</div>
            <div class="row demographicSection">
              <div class="col-md-12 rightPart">
                <div class="row" v-if="demoGrahpicInfo">
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">First Name</p>
                      <p class="value">
                        {{ patientGuarantorInfo.FirstName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Last Name</p>
                      <p class="value">
                        {{ patientGuarantorInfo.LastName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Email</p>
                      <p class="value">
                        {{ patientGuarantorInfo.Email }}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="valueWrapper">
                      <p class="label">Phone Number</p>
                      <p class="value">
                        {{ patientGuarantorInfo.MobileNumber || "--" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Message History</div>
            <div class="row">
              <div class="tableWrapper">
                <div class="gridtable">
                  <table class="table table-striped table-bordered">
                    <thead class="bg-primary">
                      <tr>
                        <th>Sent On</th>
                        <th>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(log, i) in messageHistory" :key="i">
                        <td>
                          {{ _getFormatted(log.CreateDate, "MM/DD/YYYY") }}
                        </td>
                        <td>
                          {{ log.Message }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="noData" v-if="messageHistory.length === 0">
                    No Data
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Groups</div>
            <div class="row">
              <div class="tableWrapper">
                <div class="gridtable">
                  <table class="table table-striped table-bordered">
                    <thead class="bg-primary">
                      <tr>
                        <th>Group Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(group, i) in groups" :key="i">
                        <td>
                          <div class="groupCell">
                            <div class="groupName">
                              {{ group.Name }}
                            </div>
                            <div class="groupActions"
                                 @click="_removeFromGroup(group)">
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon small v-bind="attrs" v-on="on">
                                    mdi-delete
                                  </v-icon>
                                </template>
                                <span>Remove from group</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="noData" v-if="groups.length === 0">No Data</div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Upcoming Appointments</div>
            <div class="row">
              <div class="tableWrapper">
                <div class="gridtable">
                  <table class="table table-striped table-bordered">
                    <thead class="bg-primary">
                      <tr>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Doctor</th>
                        <th>Confirm Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(appointment, i) in appointments" :key="i">
                        <td>
                          {{
                            _getFormatted(`${appointment.ApptDate}.000Z`, "MM/DD/YYYY")
                          }}
                        </td>
                        <td>
                          {{ _getFormatted(`${appointment.ApptDate}.000Z`, "h:mm a") }}
                        </td>
                        <td>{{ appointment.Provider }}</td>
                        <td>{{ appointment.Status }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="noData" v-if="appointments.length === 0">
                    No Data
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Dues</div>
            <div class="row">
              <div class="tableWrapper">
                <div class="gridtable">
                  <table class="table table-striped table-bordered">
                    <thead class="bg-primary">
                      <tr>
                        <th>Balance</th>
                        <th>Patient Responsibility Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(due, i) in dues" :key="i">
                        <td>${{ due.DueAmount }}</td>
                        <td>{{ _getFormatted(due.DueDate, "MM/DD/YYYY") }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="noData" v-if="dues.length === 0">No Data</div>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">Appointment Communication Preference</div>
            <div class="row">
              <patient-communication-preference-manager :patientId="contactId" type="appt" />
            </div>
          </div>
          <div class="sectionWrapper">
            <div class="sectionHeader">PD Communication Preference</div>
            <div class="row">
              <patient-communication-preference-manager :patientId="contactId" type="pd" :shouldSelectSingle="true" />
            </div>
          </div>
          <div class="sectionWrapper">
            <manage-patient-notes :patientId="contactId" />
          </div>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <ivr-call-initiator :patients="[patientData]"
                        :is-visible="isIvrInitiatorVisible"
                        @dismiss="_hideIvrInitiator" />

    <message-composer-dialog :patients="[patientData]"
                             :is-visible="isMessageComposerVisible"
                             :sanitize="true"
                             @dismiss="_hideMessageComposer" />

    <email-composer-dialog :patients="[patientData]"
                           :fromEmail="this.practiceDetails.email"
                           :is-visible="isEmailComposerVisible"
                           @dismiss="_hideEmailComposer" />

    <confirm-dialog :confirmButtonText="confirmAccountSyncAction.selectedActionButtonText"
                    :isVisible="isAccountSyncModalVisible"
                    :isSpinnerVisible="confirmAccountSyncAction.isDialogSpinnerVisible"
                    :dialogDescription="confirmAccountSyncAction.selectedActionDialogText"
                    @on-confirm="_onConfirmAccountSync"
                    @on-dismiss="_onDismissAccountSync" />

  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import moment from "moment";

  import { ApiCalls } from "../../../../api-calls";
  import EventEmitter from "../../../../utils/event-emitter";
  import IvrCallInitiator from "../ivr-call-initiator/ivr-call-initiator.vue";
  import EmailComposerDialog from "../email-composer/email-composer.vue";
  import MessageComposerDialog from "../message-composer/message-composer.vue";
  import PatientCommunicationPreferenceManager from "../../../../entities/patient/patient-communication-preference-manager/patient-communication-preference-manager.vue";
  import ManagePatientNotes from "../../../../entities/patient/manage-patient-notes/manage-patient-notes.vue";
  import Api from "../../../shared-module/api";

  export default {
    name: "PatientDetailsViewer",
    components: {
      IvrCallInitiator,
      MessageComposerDialog,
      EmailComposerDialog,
      PatientCommunicationPreferenceManager,
      ManagePatientNotes,
      ConfirmDialog: () => import("../../../shared-module/common-components/confirm-dialog/confirm-dialog.vue")
    },
    props: {},
    data: () => ({
      isPromptVisible: false,
      field: {
        notes: "",
        content: "",
        fromEmail: ""
      },
      patientId: "",
      displayMode: "loader",
      demoGrahpicInfo: null,
      patientGuarantorInfo: null,
      practiceDetails: {},
      messageHistory: [],
      contactId: null,
      cellNumber: "",
      groups: [],
      reviews: [],
      appointments: [],
      dues: [],
      commPreferences: [],
      patientData: {},
      isIvrInitiatorVisible: false,
      isMessageComposerVisible: false,
      isEmailComposerVisible: false,
      patientMedicalGroupId: null,
      isAccountSyncModalVisible: false,
      confirmAccountSyncAction: {
        isDialogVisible: false,
        isDialogSpinnerVisible: false,
        selectedItem: null,
        selectedAction: "sync", // or 'pause'
        selectedActionButtonText: "Sync", // or 'Pause'
        selectedActionDialogText: "Are you sure you want to sync this account?", // or 'Are you sure to pause the selected automated message?'
      },
      snackbar: false,
      notification: ''
    }),

    watch: {},

    created() {
      // this._loadMetadata();
      EventEmitter.subscribe("show-patient-details", (payload) => {
        this.isPromptVisible = true;
        if (payload) {
          // console.log('payload :>> ', payload);
          if (payload.ContactID) {
            this.selectedGroupType = payload.selectedGroupType;
            this.contactId = payload.ContactID;
            this.cellNumber = payload.CellNumber;
          }
          if (payload.MedicalGroupID) {
            this.patientMedicalGroupId = payload.MedicalGroupID
          }
        }
        this._loadPatientData();
      });
      EventEmitter.subscribe("hide-patient-details", () => {
        this.isPromptVisible = false;
      });
    },

    methods: {
      _onDismissAccountSync() {
        setTimeout(() => this._resetPatientGuarantorSyncButton(), 5000);
        
        this.isAccountSyncModalVisible = false;
      },
      _onConfirmAccountSync() {

        this.confirmAccountSyncAction.isDialogSpinnerVisible = true;

        var payload = {
          PatientID: this.demoGrahpicInfo.PatientID,
          MedicalGroupID: this.patientMedicalGroupId
        };

        var guarantorId = '';
        var patientId = '';
        var requestPayload = {};

        ApiCalls.syncPatientAccount(payload, this.demoGrahpicInfo.PatientID).then(x => {

          if (x.data && x.data.patient) {

            //set patient data
            var patient = {
              PatientId: x.data.patient.id,
              mobilePhone: x.data.patient.mobilePhone,
              email: x.data.patient.email,
              medicalGroupId: this.patientMedicalGroupId,
              practiceId: this.$store.state.posActivePractice.value,
            };

            let reqstObj = Object.assign(requestPayload, patient);

            //set display data
            this.demoGrahpicInfo.MobileNumber = x.data.patient.mobilePhone;
            this.demoGrahpicInfo.Email = x.data.patient.email;

            guarantorId = x.data.guarantor.id;
            patientId = x.data.patient.id;

            //sync guarantor data
            this._syncGuarantorAccountData(guarantorId, patientId, reqstObj);

            this.snackbar = true;
            this.notification = 'Sync Patient Account Success';
            setTimeout(() => this.snackbar = false, 5000);

          }
          else if (x.data && !x.data.patient) {

            this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
            this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
            this.confirmAccountSyncAction.isDialogVisible = true;
            this.confirmAccountSyncAction.selectedActionDialogText = x.data
            this.confirmAccountSyncAction.selectedAction = '';
            this.confirmAccountSyncAction.selectedActionButtonText = '';

          }
          else {

            this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
            this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
            this.confirmAccountSyncAction.isDialogVisible = true;
            this.confirmAccountSyncAction.selectedActionDialogText = 'Sync Patient failed. Please try again later.';
            this.confirmAccountSyncAction.selectedAction = '';
            this.confirmAccountSyncAction.selectedActionButtonText = '';

          }

        });

      },
      _syncGuarantorAccountData(guarantorId, patientId, requestPayload) {

        this.confirmAccountSyncAction.isDialogSpinnerVisible = true;

        var payload = {
          GuarantorID: guarantorId,
          PatientID: patientId,
          MedicalGroupID: this.patientMedicalGroupId
        };

        ApiCalls.syncGuarantorAccount(payload, guarantorId).then(x => {

          if (x.data) {

            //set guarantor data
            var guarantor = {
              GuarantorId: x.data.id, // referenceCode/accountId
              guarantorMobilePhone: x.data.mobilePhone,
              guarantorEmail: x.data.email,
              FirstName: x.data.firstName,
              LastName: x.data.lastName,
              FourSSN: x.data.ssn,
              Sex: x.data.sex.source,
              Address1: x.data.address1,
              Address2: x.data.address2,
              City: x.data.city,
              State: x.data.state,
              Zip: x.data.zip
            };

            let reqstObj = Object.assign(requestPayload, guarantor);

            //set display data
            this.patientGuarantorInfo.MobileNumber = x.data.mobilePhone;
            this.patientGuarantorInfo.Email = x.data.email;

            //save patient and guarantor data
            this._updatePatientGuarantorData(reqstObj);

            this.snackbar = true;
            this.notification = 'Sync Guarantor Account Success';
            setTimeout(() => this.snackbar = false, 5000);

          }
          else {

            this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
            this.confirmAccountSyncAction.isDialogVisible = true;
            this.confirmAccountSyncAction.selectedActionDialogText = 'Sync Guarantor failed. Please try again later';
            this.confirmAccountSyncAction.selectedAction = '';
            this.confirmAccountSyncAction.selectedActionButtonText = '';

          }

        });

      },
      _updatePatientGuarantorData(requestPayload) {

        //save data
        ApiCalls.updatePatientGuarantorData(requestPayload).then(x => {

          console.log(x.data);

          this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
          this.confirmAccountSyncAction.isDialogVisible = true;
          this.confirmAccountSyncAction.selectedActionDialogText = 'Patient/Guarantor data has been successfully updated.';
          this.confirmAccountSyncAction.selectedAction = '';
          this.confirmAccountSyncAction.selectedActionButtonText = '';

          this.snackbar = true;
          this.notification = 'Patient/Guarantor Data Updated';
          setTimeout(() => this.snackbar = false, 5000);

        });

      },
      _resetPatientGuarantorSyncButton() {
        this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
        this.confirmAccountSyncAction.isDialogVisible = true;
        this.confirmAccountSyncAction.selectedActionDialogText = 'Are you sure you want to sync this account?';
        this.confirmAccountSyncAction.selectedAction = 'sync';
        this.confirmAccountSyncAction.selectedActionButtonText = 'Sync';
      },
      _getFormatted(date, format) {
        return moment(date).format(format);
      },
      _showIvrInitiator() {
        this.isIvrInitiatorVisible = true;
      },
      _hideIvrInitiator() {
        this.isIvrInitiatorVisible = false;
      },
      _showMessageComposer() {
        this.isMessageComposerVisible = true;
      },
      _showAccountSync() {
        this.isAccountSyncModalVisible = true;
      },
      _hideMessageComposer() {
        this.isMessageComposerVisible = false;
      },
      _showEmailComposer() {
        this.isEmailComposerVisible = true;
      },
      _hideEmailComposer() {
        this.isEmailComposerVisible = false;
      },
      async _loadPatientData() {
        try {
          this.displayMode = "loader";
          let posPracticeID = null;
          console.log('this.$store.state.posActivePractice 11111111112:>> ', this.$store.state.posActivePractice);
          if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
            posPracticeID = this.$store.state.posActivePractice.value;
          }
          console.log('11111111112 :>> ', {
            PatientID: this.contactId,
            PracticeID: posPracticeID
          });
          const responses = await Promise.allSettled([
            this._fetchPatientInfo(this.contactId, this.patientMedicalGroupId),
            this._fetchPatientGuarantorInfo(this.contactId, this.patientMedicalGroupId),
            this._getContactHistory(this.cellNumber, posPracticeID),
            this._fetchPatientGroups(this.contactId, posPracticeID),
            this._getReviews(this.contactId),
            this._fetchPatientAppointments(this.contactId, posPracticeID),
            this._fetchPatientInvoices(this.contactId, posPracticeID),
            this._getCommPreferences(this.contactId),
            this._fetchPracticeInfo(posPracticeID),
          ]);
          console.log("responses :>> ", responses);

          // eslint-disable-next-line prefer-destructuring
          this.displayMode = "patientView";
          this.patientData = {
            email: this.demoGrahpicInfo.Email,
            first_name: this.demoGrahpicInfo.FirstName,
            hasValidNumber: true,
            id: this.demoGrahpicInfo.PatientID,
            last_name: this.demoGrahpicInfo.LastName,
            phone: this.demoGrahpicInfo.MobileNumber,
          };
          console.log("this.demoGrahpicInfo :>> ", this.demoGrahpicInfo);

          this.confirmAccountSyncAction.isDialogSpinnerVisible = false;
          this.confirmAccountSyncAction.isDialogVisible = true;
          this.confirmAccountSyncAction.selectedActionDialogText = 'Are you sure you want to sync this account?';
          this.confirmAccountSyncAction.selectedAction = 'sync';
          this.confirmAccountSyncAction.selectedActionButtonText = 'Sync';

          if (this.demoGrahpicInfo) {
            this.field.notes = this.demoGrahpicInfo.notes;
          } else {
            this.displayMode = "noData";
          }
        } catch (error) {
          console.log("error :>> ", error);
          this.displayMode = "noData";
        }
      },
      async _fetchPracticeInfo(practiceId) {
        try {
          const response = await Api.practice.private.fetchPracticeInfo({
            practiceId: practiceId
          });
          this.practiceDetails = response.data[0];
          console.log(response.data[0]);
        } catch (error) {
          console.log("error _fetchPracticeInfo: ", error);
        }
      },
      async _fetchPatientInfo(patientID, medicalGroupID) {
        try {
          const data = await Api.patient.private.fetchPatientInfo({
            PatientID: patientID,
            MedicalGroupID: medicalGroupID
          });
          this.demoGrahpicInfo = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _fetchPatientInfo: ", error);
        }
      },
      async _fetchPatientGuarantorInfo(patientID, medicalGroupID) {
        try {
          const data = await Api.patient.private.fetchPatientGuarantor({
            PatientID: patientID,
            MedicalGroupID: medicalGroupID
          });
          this.patientGuarantorInfo = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _fetchPatientGuarantorInfo: ", error);
        }
      },
      async _getContactHistory(cellNumber, practiceId) {
        try {
          const data = await ApiCalls.getContactHistory({
            CellNumber: cellNumber,
            PracticeID: practiceId
          });
          this.messageHistory = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _getContactHistory: ", error);
        }
      },
      async _fetchPatientGroups(patientID, posPracticeID) {
        try {
          const data = await Api.patient.private.fetchPatientGroups({
            PatientID: patientID,
            POSPracticeID: posPracticeID
          })
          this.groups = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _fetchPatientGroups: ", error);
        }
      },
      async _getReviews(patientID) {
        try {
          const data = await ApiCalls.getReviews(patientID);
          this.reviews = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _getReviews: ", error);
        }
      },
      async _fetchPatientAppointments(patientID, posPracticeID) {
        try {
          const data = await Api.patient.private.fetchPatientAppointments({
            PatientID: patientID,
            POSPracticeID: posPracticeID
          });
          this.appointments = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _fetchPatientAppointments: ", error);
        }
      },
      async _fetchPatientInvoices(patientID, posPracticeID) {
        try {
          const data = await Api.patient.private.fetchPatientInvoices({
            PatientID: patientID,
            POSPracticeID: posPracticeID
          });
          this.dues = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _fetchPatientInvoices: ", error);
        }
      },
      async _getCommPreferences(patientID) {
        try {
          const data = await ApiCalls.getCommPreferences(patientID);
          this.commPreferences = this._getFormattedValueFromApiResponse(data);
        } catch (error) {
          console.log("error _getCommPreferences: ", error);
        }
      },
      _getFormattedValueFromApiResponse(value, defaultValue = []) {
        if (value && value.data) {
          return value.data;
        }
        return defaultValue;
      },
      async _updateContact() {
        this.displayMode = "loader";
        try {
          await ApiCalls.updateContact(this.contactId, {
            ...this.demoGrahpicInfo,
            notes: this.demoGrahpicInfo.notes,
          });
        } catch (error) {
          console.log("error :>> ", error);
        }
        this.displayMode = "patientView";
      },
      dismiss() {
        this._reset();
        this.isPromptVisible = false;
      },
      _removeFromGroup(group) {
        // Remove locally
        const index = this.groups.findIndex((g) => g.GroupID === group.GroupID);
        if (index > -1) {
          this.groups.splice(index, 1);
        }
        ApiCalls.removePatientFromGroup(group.GroupID, this.contactId)
      },
      _reset() {
        this.field = {
          notes: "",
        };
        this.patientId = "";
        this.displayMode = "loader";
        this.demoGrahpicInfo = null;
        this.messageHistory = [];
        this.contactId = null;
        this.cellNumber = "";
        this.groups = [];
        this.reviews = [];
        this.appointments = [];
        this.dues = [];
        this.commPreferences = [];
      }
    },
  };
</script>
<style lang="scss" scoped>
  .progressWrapper {
    width: 100%;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .spinner {
      margin-left: 0rem !important;
    }

    flex-direction: column;

    img {
      margin-bottom: 25px;
    }

    .dismissButton {
      position: absolute;
      top: 1rem;
      right: 1.5rem;
      background-color: red;
      box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
      color: white;
      padding: 3px 35px;
      border-radius: 15px;
      z-index: 9999;
    }
  }

  .patientViewerOuterWrapper {
    min-height: 500px;
    max-height: 90vh;
    position: relative;
    overflow-x: hidden;

    .dismissButton {
      position: absolute;
      top: 1rem;
      right: 1.5rem;
      background-color: red;
      box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
      color: white;
      padding: 3px 35px;
      border-radius: 15px;
      z-index: 9999;
    }
  }

  .patientViewWrapper {
    width: 1200px;
    min-height: 500px;
    max-height: 90vh;
    background-color: #f2f5f9;
    overflow-y: scroll;
    padding: 2rem;
    padding-top: 4rem;

    .sectionWrapper {
      padding: 2rem;
      width: 100%;
      min-height: 300px;
      box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.04);
      background: white;
      border-radius: 15px;
      margin-bottom: 50px;
    }

    .notesWrapper {
      width: 100%;

      textarea {
        width: 100%;
        background-color: #eff1f7;
        border-radius: 5px;
        padding: 5px 15px;
        outline: none;
      }

      .notesSaveBtn {
        padding: 3px 40px;
        border-radius: 10px;
        background-color: black;
        color: white;
      }
    }

    .demographicSection {
      .leftPart {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .patientName {
          margin-top: -25px;
        }

        .profileImageWrapper {
          img {
            // border: 3px solid black;
            width: 200px;
            height: 200px;
            border-radius: 200px;
          }
        }
      }

      .rightPart {
        // border-left: 1px solid rgb(202, 202, 202);
        padding-top: 1.5rem;
        padding-left: 1.5rem;
      }

      .valueWrapper {
        .label {
          color: rgb(133, 133, 133);
          font-weight: 600;
        }

        .value {
          color: rgb(39, 39, 39);
          font-weight: 600;
          height: 30px;
        }

        border-bottom: 1px solid rgb(221, 220, 220);

        &.noBorder {
          border: none;
        }
      }
    }

    .sectionHeader {
      font-size: 1.2rem;
      padding: 6px 25px;
      margin-top: -14px;
      margin-bottom: 35px;
      widows: 100%;
      background: rgb(0, 182, 91);
      // text-align: center;
      color: white;
      border-radius: 15px;
      margin-left: -5px;
    }
  }

  .tableWrapper {
    padding: 1rem 3rem;

    .gridtable tbody {
      display: block;
      max-height: 150px;
      overflow-y: scroll;
    }

    .gridtable thead,
    .gridtable tbody tr {
      display: table;
      table-layout: fixed;
      width: 100%;
    }

    .gridtable thead {
      width: calc(100% - 1.1em);
    }

    .gridtable thead {
      position: relative;
    }

    th {
      text-align: left;
      padding: 3px 15px;
      font-weight: 600;
      font-size: 1rem;
      border-radius: 15px;
    }

    thead {
      tr {
        background-color: rgb(226, 221, 221);
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid rgb(202, 202, 202);
      }
    }

    td {
      padding: 3px 15px;
    }

    .gridtable thead th:last-child:after {
      content: " ";
      position: absolute;
      // background-color: #337ab7;
      width: 1.3em;
      height: 38px;
      right: -1.3em;
      top: 0;
      border-bottom: 2px solid #ddd;
    }

    .noData {
      width: 100%;
      text-align: center;
      padding-top: 50px;
    }
  }

  .patientActions {
    position: absolute;
    top: 0.5rem;
    left: 2.5rem;
    background-color: #000000;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
    color: white;
    border-radius: 40px;
    z-index: 9999;
    width: 250px;
    min-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 5px;

    .actionLabel {
      padding-left: 20px;
      font-weight: 600;
    }

    .actionWrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 130px;

      .actionBtn {
        width: 30px;
        height: 30px;
        cursor: pointer;
        background-color: rgb(255, 255, 255);
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        * {
          color: black;
          //font-size: 15px;
        }
      }
    }
  }

  .patientAccountSync {
    position: absolute;
    margin: -49px 0px 0px 38%;
    background-color: #000000;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
    color: white;
    border-radius: 40px;
    z-index: 9999;
    width: 250px;
    min-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 5px;

    .actionLabel {
      padding-left: 20px;
      font-weight: 600;
    }

    .actionWrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: auto;

      .actionBtn {
        width: 30px;
        height: 30px;
        cursor: pointer;
        background-color: rgb(255, 255, 255);
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        * {
          color: black;
          /*font-size: 15px;*/
        }
      }
    }
  }

  .groupCell {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .groupActions {
      margin-right: 2rem;
      cursor: pointer;
    }
  }

  .demoGrahpicInfoID {
    width: 20px; /* can be 100% ellipsis will happen when contents exceed it */
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .demoGrahpicInfoID:hover {
    white-space: nowrap;
    overflow: visible;
  }
</style>
